import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RefreshCw } from 'lucide-react';
import { fetchUserJobs } from '../../../redux/JobSlice/jobSlice';

const JobSubHeader = ({
    localLoading,
    searchResult,
    handleFetchMoreJobs,
}) => {
    const dispatch = useDispatch();
    const { syncing } = useSelector((state) => state.jobs);

    return (
        <div className="flex items-center gap-3 w-full">
                {/* Left: title + count */}
                <div className="flex items-center gap-2 min-w-0">
                    <span className="text-[15px] font-bold text-[#0f172a]">Job Listings</span>
                    <span className="text-sm text-gray-500 font-normal">
                        {searchResult} job{searchResult !== 1 ? 's' : ''}
                    </span>
                </div>

                <div className="flex-1" />

                {/* Right: actions */}
                <button
                    onClick={() => dispatch(fetchUserJobs())}
                    disabled={syncing || localLoading}
                    className="flex items-center gap-1.5 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 px-3 py-2 rounded-lg transition-colors border border-transparent hover:border-gray-200 flex-shrink-0"
                >
                    <RefreshCw className={`w-3.5 h-3.5 ${syncing ? 'animate-spin' : ''}`} />
                    Refresh
                </button>

                <button
                    onClick={handleFetchMoreJobs}
                    disabled={localLoading}
                    className="flex items-center gap-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 hover:border-gray-300 px-4 py-2 rounded-lg transition-colors flex-shrink-0"
                >
                    {localLoading ? 'Fetching…' : 'Fetch more jobs'}
                </button>

        </div>
    );
};

export default JobSubHeader;
